import {
    putConfiCostLoading,
    putConfiCostRequest,
    putConfiCostSuccess,
    putConfiCostReject,
    putConfiCostReset
} from "../../actions/costGlobal/put";

export const putConfiCost = (formData) => async (dispatch, getState) => {
    dispatch(putConfiCostLoading());
    try {
        const { data } = await putConfiCostRequest(formData, getState);
        dispatch(putConfiCostSuccess(data))
    } catch (error) {
        dispatch(putConfiCostReject(error))
    } finally {
        setTimeout(() => { dispatch(putConfiCostReset()) }, 3000);
    }
    return Promise.resolve();
};